import React from 'react';
import type { TpTreatmentPitch } from '../../patient-treatment/types';
import { tpTotalOOP } from '../../patient-treatment/utils';
import { PatientProfileTabSectionHeader } from './PatientProfileTabSectionHeader';
import { PatientTreatmentPitchCard } from './PatientTreatmentPitchCard';

export interface PatientTreatmentSellSequenceProps {
  treatments: TpTreatmentPitch[];
}

export function PatientTreatmentSellSequence({ treatments }: PatientTreatmentSellSequenceProps) {
  const totalOOP = tpTotalOOP(treatments);

  return (
    <section className="tc-rise tc-d3 mb-[30px]">
      <PatientProfileTabSectionHeader
        eyebrow="Treatments to pitch · in order"
        title="Sell sequence"
        meta={`${treatments.length} items · $${totalOOP.toLocaleString()} total OOP`}
        icon="bars"
      />
      <div>
        {treatments.map((tx, i) => (
          <PatientTreatmentPitchCard key={tx.id} tx={tx} last={i === treatments.length - 1} />
        ))}
      </div>
    </section>
  );
}
